import axios from "axios";
import { ApiLink } from "../APILink/ApiLink";
import { errorAlert } from "../Components/Alerts";

export const getMenuItemByID = async (headers, id) => {
  try {
    const response = await axios.get(
      `${ApiLink.API_URL}MenuItem/menuItemByID/${id}`,
      { headers }
    );

    console.log(response.data);
    
    return response.data;
  } catch (error) {
    console.error("Gabim në kërkesë:", error);

    if (error.response?.data?.errorMessage) {
      errorAlert(`Gabim: ${error.response.data.errorMessage}`);
    } else if (error.message) {
      errorAlert(`Gabim: ${error.message}`);
    } else {
      errorAlert("Gabim i panjohur.");
    }

    return null;
  }
};

